import { ITrainingTemplateResource } from "@sol/sdk/training-templates";
import { mapRelationalFilter, RelationalFilter } from "@sol/sdk/utils";

import { IHydraList } from "../../types";
import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { serialize } from "../../utils/url";
import { ITrainingActionResource } from "../types/ITrainingActionResource";

export interface ITrainingActionListQueryParameters
    extends IPaginateable, IOrderable<"type" | "createdAt" | "updatedAt" | "rank"> {
    filters?: {
        type?: string;
        trainingTemplates?: RelationalFilter<ITrainingTemplateResource>;
    };
}

export type ITrainingActionListQueryResult = IHydraList<ITrainingActionResource>;

const mapFilters = (filters: ITrainingActionListQueryParameters["filters"]) => {
    const { type, trainingTemplates } = filters ?? {};

    return {
        type,
        "trainingTemplate.uuid": mapRelationalFilter(trainingTemplates),
    };
};

export const trainingActionListQuery: IApiQueryFunction<ITrainingActionListQueryParameters> = ({
    filters,
    pagination,
    order,
}) => {
    return {
        method: "GET",
        url: `/training_actions${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useTrainingActionListQuery = createApiQueryHook<
    ITrainingActionListQueryParameters,
    ITrainingActionListQueryResult
>(trainingActionListQuery);
